import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../components/login.vue'
import home from '../components/home.vue'
import FeedBack from '../components/feedback.vue'
import board from '../components/board.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/', name:'login',component: login }, //
  /*  { path: '/login',name:'login', component: login },*/
    {
      path: '/home',
      component: home,
      redirect: '/feedback',
      children: [
        { path: '/feedback',name:'feedback', component: FeedBack },
        { path: '/board', name:'board',component: board }
      ]
    }
  ]
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {

  const tokenStr = window.sessionStorage.getItem('feedback')
  if (!tokenStr) {
    if(to.name=='login'){
      next();
    }else{
      next('/')
    }
  }else{
      next();
  }
  // // 获取token
})

export default router
